module.exports = __webpack_public_path__ + "static/media/cont612.c2d6f00.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont612.mp4
// module id = H/St
// module chunks = 0